var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-icon',{staticClass:"mr-2",on:{"click":function($event){_vm.darkMode = !_vm.darkMode}}},[_vm._v(" "+_vm._s(_vm.darkMode ? 'mdi-weather-night' : 'mdi-white-balance-sunny')+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }